export const RegisterDeviceValidation = (json, isEditMode) => {

    const MyPromise = new Promise((resolve, reject) => {
        var errorJson = {};

        // Required field: Device Name
        if (json?.deviceName === undefined || json?.deviceName === '' || json?.deviceName?.trim() === '') {
            Object.assign(errorJson, { deviceName: "Device name cannot be empty *" });
        }

        // Required field: Device Type
        if (json?.deviceType === undefined || json?.deviceType === '') {
            Object.assign(errorJson, { deviceType: "Device type cannot be empty *" });
        }

        // Required field: Status
        if (json?.status === undefined || json?.status === '') {
            Object.assign(errorJson, { status: "Status cannot be empty *" });
        }

        // Optional field: Orientation (isVertical is boolean, always defined, no need to validate)
        // The orientation string is derived from isVertical, so no validation needed

        // Optional field: Resolution
        // Resolution is optional, no validation needed

        // Optional field: Latitude (validate range if provided)
        if (json?.lat && json?.lat !== '') {
            const lat = parseFloat(json.lat);
            if (isNaN(lat) || lat < -90 || lat > 90) {
                Object.assign(errorJson, { lat: "Invalid latitude (must be between -90 and 90) *" });
            }
        }

        // Optional field: Longitude (validate range if provided)
        if (json?.lng && json?.lng !== '') {
            const lng = parseFloat(json.lng);
            if (isNaN(lng) || lng < -180 || lng > 180) {
                Object.assign(errorJson, { lng: "Invalid longitude (must be between -180 and 180) *" });
            }
        }

        resolve(errorJson);
    });

    return MyPromise;
}
